import { Document } from '@/types/documents';
import { storageEdgeUrl } from '@/utils/constants';

export const getDocUrl = (document: Document | undefined) => {
    if (!document) return;

    return `${storageEdgeUrl}/${document.document?.filename_disk}`;
};

export const getSvgFile = (file_id: string) => {
    if (!document) return;
    return `${storageEdgeUrl}/${file_id}.svg`;
};
